import { createUseStyles } from '@glu/theming';

const styles = ({ indicators }) => ({
  root: {
    fontFamily: indicators.fontFamily
  },
  messaging: {
    display: 'flex',
    fontSize: 10,
    fontWeight: '700',
    justifyContent: 'space-between',
    lineHeight: '16px',
    textTransform: 'uppercase',
    color: ({ dark }) => (dark ? indicators.dark.textColor : indicators.textColor)
  }
});

export default createUseStyles(styles);
